export default "__VITE_ASSET__ebec4744__"